import { IDataType } from "../../../shared/definitions/datatypes";
import { IObject } from "../../../shared/utils/utils";

interface IDatamodelAssociation {
columns: string[];
datamodel_type: string;
datamodel_id: string;
alertcase_id: string;
alerted_only?: boolean;
include_alerted_info?: boolean;
}

export interface IText {
  type: "text";
}

export interface IColumn {
  key: string;
  displayName: string;
  dataType: IDataType;
  sortable?: boolean;
}

export function transformToBackendDatamodelAssociation(data: IDatamodelAssociation) {
  return {
    columns: data.columns,
    datamodel_type: data.datamodel_type,
    datamodel_id: data.datamodel_id,
    alertcase_id: data.alertcase_id,
    alerted_only: data.alerted_only || false,
    include_alerted_info: data.include_alerted_info || false
  };
}

export function transformFromBackendDatamodelAssociation(backendType: any) { // eslint-disable-line
  const rows = (backendType.data ?? []).map((row: IObject) => ({
    id: row.sygno_id,
    ...row
  }));
  return {
    rows
  };
}
